import React, { useState } from 'react';
import './OrderBasicInfo.scss';
import { CopyText, Tooltip, MenuWidget } from '../../../../UiKit';
import styled from 'styled-components';
import Shimmer from 'sushiweb/Shimmer';
import { getFullDate } from '../../../commons/CommonMethods';
import { AppDetails } from '../../../tooltip';
import { OrdersInSameCartModal } from './OrdersInCartModal';
import { OrderTagDetailsModal } from './OrderTagDetailsModal';
import { ToolTip } from '../../../ComponentsV1/ToolTip/Tooltip';
import { Info } from 'lucide-react';

const dashboardMode = window.dashboard.mode;

export const OrderBasicInfo = ({
  order = null,
  getReplaceOrderBasicInfo = () => {},
}) => {
  const [isVisible, setVisible] = useState();
  const [orderTagDetailsPopUp, setorderTagDetailsPopUp] = useState();
  const [orderTagPopUpInfo, setOrderTagPopUpInfo] = useState();

  const handleClose = () => setVisible(false);

  const closeOrderTagPopUp = () => setorderTagDetailsPopUp(false);

  const showTagLabel = (texts) => {
    if (!texts) return '';
    return () => (
      <div
        css={`
          display: flex;
          flex-direction: column;
        `}
      >
        {texts.map((text) => {
          return <div>{text}</div>;
        })}
      </div>
    );
  };

  const handleTagDetailsPopup = (tag) => {
    if (tag.meta?.data) {
      setorderTagDetailsPopUp((prevState) => !prevState);
      setOrderTagPopUpInfo(tag.meta);
    }
  };

  return (
    <div className='basicInfoContainer'>
      {orderTagDetailsPopUp ? (
        <OrderTagDetailsModal
          handleClose={closeOrderTagPopUp}
          tagInfo={orderTagPopUpInfo}
        />
      ) : null}
      <OrdersInSameCartModal
        isVisible={isVisible}
        handleClose={handleClose}
        cartId={order?.cart_id}
      />

      {!order ? (
        <Shimmer height='6rem' width='100%' />
      ) : (
        <div className={`orderIdInfo ${dashboardMode}`}>
          <h3 className='orderId'>
            {order?.app_details && (
              <ToolTip
                className='!tw-bg-white'
                closeDelay={'100'}
                placement='right'
                content={
                  <AppDetails
                    appDetails={order.app_details}
                    deviceDetails={order.device_details}
                  />
                }
              >
                <div className='tw-cursor-pointer'>
                  <Info
                    size={16}
                    className={`tw-mr-1 ${
                      order.device_details?.is_blocked
                        ? 'tw-text-[#FF0000]'
                        : 'tw-text-zinc-700'
                    }`}
                    strokeWidth={2.2}
                  />
                </div>
              </ToolTip>
            )}
            {order.order_id && (
              <>
                {order.replacement_order ? (
                  <MenuWidget
                    title={String(order.order_id)}
                    menuText={String(order.replacement_order)}
                    onMenuSelect={getReplaceOrderBasicInfo.bind(
                      this,
                      order.replacement_order,
                    )}
                    hideText={false}
                  />
                ) : (
                  <>
                    <span>Order&nbsp;#</span>
                    <CopyText title={order.order_id} />
                  </>
                )}
              </>
            )}
            <>
              <span className='iconMarginL'>{`Ord id #`}</span>
              <CopyText title={order.gr_id} />
            </>
            <Tooltip
              position='bottom'
              border={false}
              title={
                <>
                  <span
                    onClick={() => setVisible(true)}
                    style={{ textDecoration: 'underline', cursor: 'pointer' }}
                    className='iconMarginL'
                  >
                    Cart id
                  </span>
                </>
              }
              label={'Linked orders'}
            />
            &nbsp;#
            <CopyText title={order.cart_id} />
            {order.id && (
              <>
                <span>SubOrder&nbsp;#</span>
                <CopyText title={order.id} />
              </>
            )}
            {!!order.instant && (
              <div className='instantImage'>
                <img src={order.instant.image} alt='' />
              </div>
            )}
          </h3>
          {order.master_order_id && (
            <>
              <h2 className='masterOrderId'>
                <span>Master-Order&nbsp;#</span>
                <CopyText title={order.master_order_id} />
              </h2>
            </>
          )}
          <div className='lighter date'>
            {getFullDate(order.created_at)}
            {order.order_tags.length ? (
              <div className='iconMarginL tagToolTip'>
                {order.order_tags.map((tag, index) => {
                  if (tag.image) {
                    return (
                      <ImgWrapper>
                        <img
                          src={tag.image}
                          height='100%'
                          width='100%'
                          alt={tag.text}
                        />
                      </ImgWrapper>
                    );
                  }
                  return (
                    <Tooltip
                      position='bottom'
                      border={false}
                      title={
                        <div
                          onClick={() => {
                            handleTagDetailsPopup(tag);
                          }}
                          className={`${
                            tag.meta?.data
                              ? 'tw-cursor-pointer'
                              : 'tw-cursor-auto'
                          }`}
                        >
                          <OrderTag
                            key={index}
                            bgColor={tag.bg_color}
                            textColor={tag.color}
                          >
                            {tag.text}
                          </OrderTag>
                        </div>
                      }
                      label={
                        tag?.hover_texts && tag?.hover_texts.length > 0
                          ? showTagLabel(tag?.hover_texts)
                          : ''
                      }
                    />
                  );
                })}
              </div>
            ) : null}

            {order.resolved_issue_count > 0 ? (
              <OrderTag bgColor='brown' textColor='white'>
                Resolved Issues : {order.resolved_issue_count}
              </OrderTag>
            ) : null}
          </div>
        </div>
      )}
    </div>
  );
};

const OrderTag = styled.div`
  margin-right: 0.5rem;
  height: fit-content;
  padding: 0 1rem;
  background-color: ${({ bgColor }) => bgColor};
  color: ${({ textColor }) => textColor};
  font-size: 1.2rem;
  border-radius: 0.4rem;
`;

const ImgWrapper = styled.div`
  height: 26px;
  margin-right: 0.5rem;
`;
